<template>
    <div class="loader" id="preload"></div>
</template>

<script>
    export default {
        name: 'Loader'
    }
</script>